import styled from 'styled-components';

const getStatusGradient = (status) => {
  switch(status) {
    case 'blue':
      return `linear-gradient(71deg, #376da9 -56%, #061e39 78%)`;
    case 'red':
      return `linear-gradient(255deg, #ff3e5e -56%, #ff7f3f 78%)`;
    case 'yellow':
      return `linear-gradient(255deg, #f89d19 -56%, #ffc62a 78%)`;
    default:
      return `linear-gradient(71deg, #376da9 -56%, #061e39 78%)`;
  }
}

export const BookingStatusOuterWrap  =styled.div(
  props => `
    width:100%;
    height: 21rem;
    display: flex;
    border-radius: 1rem;
    background-image: ${getStatusGradient(props.status)};
    margin-bottom: ${props.theme.spacing.large.l15};
    justify-content: space-between;
  `
);

export const BookingStatusInnerWrap = styled.div(
  props => `
    width:65%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l20};
  `
);

export const BookingStatusHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font22};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const BookingStatusInfoWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.nospacing} ${props.theme.spacing.base};
  `
);

export const BookingEmailInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.white.base};
  `
);

export const BookingIdWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding-bottom: ${props.theme.spacing.large.l15};
  `
);

export const BookingIdText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.black};

    span{
        font-weight:normal;
    }
  `
);

export const ManagerBookingBtnWrap = styled.div(
  props => `
    display: flex;
    align-self: flex-start;
  `
);

export const ManageBtn = styled.button(
  props => `
    display: flex;
    padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.large.l20};
    border: 0.8px solid ${props.theme.colors.white.base};
    border-radius: 1.7rem;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    background-color: transparent;
    outline: none;
    text-transform: uppercase;
    cursor: pointer;
  `
);

export const ThanYouStatusImgWrap = styled.div(
  props => `
    width:35%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  `
);
